module.exports = __webpack_public_path__ + "img/Support-skill-519.ed4891b7.png";